// 轮播图广告
import React, { useEffect, useMemo } from 'react'

import { useAdStat } from 'Components/ad'
import Label from './left-label'
import { ISwiperAD } from './interface'
import applyHttpsImage from 'lib/apply-https-img'

interface IProps {
  /**
   * 当前的序号
   */
  index: number
  /**
   * 广告数据
   */
  data: ISwiperAD
}
function SwiperAD({ data, index }: IProps) {
  const customStat = useMemo(
    () => ({
      rank: index,
      ad_picture_url: data.image.url,
    }),
    [data.image.url, index]
  )
  const { ref, handleClick } = useAdStat(
    {
      send: 'ad_send_home_carousel_banner',
      show: 'ad_show_home_carousel_banner',
      click: 'ad_click_home_carousel_banner',
    },
    data,
    customStat
  )
  return (
    <div
      ref={ref}
      onClick={() => {
        handleClick()
        setTimeout(() => {
          window.open(data.web_url, '_blank')
        }, 50)
      }}
    >
      <img src={applyHttpsImage(data.image.url)} />
      <Label text={data.label} />
      <style jsx>
        {`
          div {
            position: relative;
            height: 316px;
            width: 800px;
          }
          img {
            width: 100%;
            vertical-align: middle;
          }
        `}
      </style>
    </div>
  )
}
export default SwiperAD
